import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button, Spinner } from '@yhelp/ui';
import { formatAuth0Error } from '@/auth/auth0-errors';
import { AuthLayout } from '@/templates/AuthLayout';

export function CallbackPage() {
  const { handleRedirectCallback, error } = useAuth0();
  const navigate = useNavigate();
  const [callbackError, setCallbackError] = useState<string | null>(null);

  const queryError = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const description = params.get('error_description');
    const code = params.get('error');
    if (!description && !code) return null;
    return formatAuth0Error(description ?? code);
  }, []);

  useEffect(() => {
    if (queryError) return;

    void (async () => {
      try {
        const result = await handleRedirectCallback();
        const returnTo =
          (result?.appState as { returnTo?: string } | undefined)?.returnTo ?? '/app';
        void navigate({ to: returnTo });
      } catch (err) {
        console.error('[yhelp] handleRedirectCallback failed', err);
        setCallbackError(formatAuth0Error(err));
      }
    })();
  }, [handleRedirectCallback, navigate, queryError]);

  const message = queryError ?? callbackError ?? (error ? formatAuth0Error(error) : null);

  if (message) {
    return (
      <AuthLayout title="Erro ao entrar" subtitle="Não foi possível concluir o login">
        <p className="text-center text-sm text-priority-critico" role="alert">
          {message}
        </p>
        <div className="mt-6 flex justify-center">
          <Button variant="secondary" onClick={() => void navigate({ to: '/' })}>
            Voltar ao início
          </Button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Conectando" subtitle="Finalizando autenticação com Auth0">
      <div className="flex justify-center py-8">
        <Spinner size="lg" label="Conectando…" />
      </div>
    </AuthLayout>
  );
}
